export const API_KEY = "AIzaSyCO3VyIHOrB1KNzZJd7TVTahkPrOcA9GbI";

export default API_KEY;